/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoUpdateShipmentInput = {
    clientMutationId?: string | null;
    slug: string;
    shipmentKey: string;
    containerSlug: string;
    profileImageSlug?: string | null;
    shipmentType: string;
    vin?: string | null;
    description: string;
    weight?: number | null;
    parentShipment?: string | null;
    dischargeDate?: string | null;
    shipperReleaseCheck?: boolean | null;
    runs?: boolean | null;
    finalReleaseCheck?: boolean | null;
    atbPosition?: string | null;
    customsType?: string | null;
    customsReference?: string | null;
    vinEngine?: string | null;
    vinFuelType?: string | null;
    vinBodyClass?: string | null;
    vinOrigin?: string | null;
    linkedContacts: Array<LinkedContactInput>;
    deliveryLocation?: string | null;
};
export type LinkedContactInput = {
    role: string;
    contactSlug: string;
};
export type ShipmentEditMutationVariables = {
    input: infoUpdateShipmentInput;
};
export type ShipmentEditMutationResponse = {
    readonly infoUpdateShipment: {
        readonly shipment: {
            readonly slug: string;
        };
    } | null;
};
export type ShipmentEditMutation = {
    readonly response: ShipmentEditMutationResponse;
    readonly variables: ShipmentEditMutationVariables;
};



/*
mutation ShipmentEditMutation(
  $input: infoUpdateShipmentInput!
) {
  infoUpdateShipment(input: $input) {
    shipment {
      slug
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShipmentEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateShipmentPayload",
        "kind": "LinkedField",
        "name": "infoUpdateShipment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Shipment",
            "kind": "LinkedField",
            "name": "shipment",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShipmentEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateShipmentPayload",
        "kind": "LinkedField",
        "name": "infoUpdateShipment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Shipment",
            "kind": "LinkedField",
            "name": "shipment",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc7ead3681d40e5da8d5cd2171733e82",
    "id": null,
    "metadata": {},
    "name": "ShipmentEditMutation",
    "operationKind": "mutation",
    "text": "mutation ShipmentEditMutation(\n  $input: infoUpdateShipmentInput!\n) {\n  infoUpdateShipment(input: $input) {\n    shipment {\n      slug\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '36325fbdc4bc43fc2379ae1d51c084c7';
export default node;
